import React from 'react'
import DeadlinesEdit from './deadlinesEdit/DeadlinesEdit';

function Index(
    {
        expanded
    }) {
    return (
        expanded && <DeadlinesEdit/>
    )
}

export default Index;